import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';

export const getReportsPrefsSearchState = createSelector(
  fromFeature.getReportsPrefsState,
  (state: fromFeature.ReportPrefsResultsState) => state.prefs
);
